import { Field, useField, useForm, useFormState } from 'react-final-form';
import styles from './LoanFormInstallment.module.scss';
import MeritoRadioButton from '../components/RadioButton/MeritoRadioButton';
import { InstallmentType } from '../../../interfaces/interfaces';
import { OnChange } from 'react-final-form-listeners'
import { useMemo, useState } from 'react';
import OutlinedFormInput from '../components/OutlinedFormInput/OutlinedFormInput';
import { onBlurFormatNumber, parseNumberForDB } from '../../../components/functions/utilities';
import { FieldArray } from 'react-final-form-arrays';
import moment from 'moment';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { datesError } from './LoanForm';
import { OverlayTrigger } from 'react-bootstrap';
import { RenderSideBarTooltip } from '../../../components/common/RenderTooltip';

type Props = {
    validateBothDates: (startDate: Date, endDate: Date, checkAllFields: boolean, allValues: { [x: string]: any }) => { errorsObj: any, isError: boolean },
    handleVariableMonths: (values: { [x: string]: any }, batch: any, change: any, forceChange?: boolean) => void
}


const LoanFormInstallment = ({ validateBothDates, handleVariableMonths }: Props) => {
    const { getState, getFieldState, batch, change, mutators } = useForm();
    const [installmentType, setInstallmentType] = useState<InstallmentType>(getState()?.values['installmentType']);
    const { meta: startDateMeta } = useField("startDate", { subscription: { touched: true, error: true } });

    const formValues = getState()?.values;

    const isInstallmentSectionDisabled = useMemo(() => {
        const startDateFieldState = getFieldState('startDate')
        const endDateFieldState = getFieldState('endDate')
        // console.log('formValues', formValues);
        const { isError } = validateBothDates(formValues?.startDate, formValues?.endDate, true, formValues)

        // console.log('isError', isError)
        // if (!startDateFieldState || !endDateFieldState) {
        //     return true;
        // } else if (startDateFieldState['error'] || endDateFieldState['error']) {
        //     return true;
        // } else {
        //     return false;
        // }
        return isError
    }, [formValues])

    const { meta: monthsMeta, input: { value: monthsValue } } = useField("months", { subscription: { touched: true, error: true, value: true, visited: true } });
    const { touched } = useFormState();

    // console.log('meta of selectedMetric', meta);
    // console.log('typeOfAmountValue', typeOfAmountValue)
    const isFieldArrayTouchedOrVisited = useMemo(() => {
        // console.log('touched', touched);
        const touchedFields = Object.keys(touched).reduce((prev, curVal) => {
            if (touched[curVal]) {
                prev.push(curVal);
            }
            return prev;
        }, []);

        const isTouched = touchedFields.some(key => key.startsWith(`months[`));

        return { isTouched };
    }, [touched]);

    // console.log('isFieldArrayTouchedOrVisited', isFieldArrayTouchedOrVisited)

    // console.log('isInstallmentSectionDisabled', isInstallmentSectionDisabled)

    return (
        <>
            {startDateMeta.touched && startDateMeta.error && startDateMeta.error == datesError.withingRange ? null

                :
                <div className={styles.installmentContainer}>
                    <Field name="installmentType" >
                        {(props) => {
                            return (
                                <MeritoRadioButton
                                    {...props.input}
                                    label="Instalments"
                                    radioLabels={[
                                        {
                                            label: "Fixed",
                                            value: InstallmentType.fixed,
                                            disabledState: isInstallmentSectionDisabled,
                                            disabledMessage: 'Fill above details to proceed.'
                                        },
                                        {
                                            label: "Variable",
                                            value: InstallmentType.variable,
                                            disabledState: isInstallmentSectionDisabled,
                                            disabledMessage: 'Fill above details to proceed.'
                                        },

                                    ]}
                                    name={props.input.name}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                    error={props.meta.error}
                                // fieldContainerStyle={{ marginBottom: "0.8rem" }}
                                />
                            )
                        }}
                    </Field>
                    <OnChange name="installmentType">
                        {(value, previous) => {
                            if (value == InstallmentType.fixed) {
                                setInstallmentType(InstallmentType.fixed);
                                handleVariableMonths(formValues, batch, change, true)
                            } else {
                                setInstallmentType(InstallmentType.variable)
                                handleVariableMonths(formValues, batch, change, true)
                            }
                        }}
                    </OnChange>

                    {installmentType == InstallmentType.fixed ?
                        <OverlayTrigger
                            placement="right"
                            trigger={"hover"}
                            delay={{ show: 100, hide: 100 }}
                            overlay={(props) =>
                                isInstallmentSectionDisabled ? RenderSideBarTooltip(
                                    { ...props },
                                    'Fill above details to proceed.',
                                    "left"
                                ) : <></>
                            }
                        >
                            <div style={{ width: "48%" }}>
                                <Field
                                    name={`installmentAmount`}
                                    validate={(value) => {
                                        if (!value) {
                                            return `Enter Instalment Amount`
                                        }
                                    }}
                                >
                                    {(props) => (

                                        <OutlinedFormInput
                                            {...props.input}
                                            label="Instalment Amount"
                                            inpuType="number"
                                            disabled={isInstallmentSectionDisabled}
                                            name={props.input.name}
                                            value={props.input.value}
                                            onChange={(e) => {
                                                const numericValue = parseNumberForDB(e.target.value, false);
                                                props.input.onChange(numericValue);
                                            }}
                                            error={props.meta.error}
                                            touched={props.meta.touched}
                                            onBlur={(e) => {
                                                const value = props.input.value;
                                                const formattedValue = onBlurFormatNumber(value, 0);
                                                props.input.onChange(formattedValue);
                                                props.input.onBlur(e);
                                            }}
                                            unitPlaceHolder={'₹'}
                                            maxLength={21}
                                            isCurrency={true}
                                        />

                                    )}
                                </Field>
                            </div>
                        </OverlayTrigger>
                        :
                        <>
                            <div className={styles.applyToAllRootContainer}>
                                <div className={styles.inputFieldContainer}>

                                    <Field
                                        name={`applyToAll`}
                                    >
                                        {(props) => (
                                            <OutlinedFormInput
                                                {...props.input}
                                                inpuType="number"
                                                disabled={isInstallmentSectionDisabled}
                                                name={props.input.name}
                                                value={props.input.value}
                                                onChange={(e) => {
                                                    const numericValue = parseNumberForDB(e.target.value, false);
                                                    props.input.onChange(numericValue);
                                                }}
                                                error={props.meta.error}
                                                touched={props.meta.touched}
                                                onBlur={(e) => {
                                                    const value = props.input.value;
                                                    const formattedValue = onBlurFormatNumber(value, 0);
                                                    props.input.onChange(formattedValue);
                                                    props.input.onBlur(e);
                                                }}
                                                unitPlaceHolder={'₹'}
                                                maxLength={21}
                                                isCurrency={true}
                                            />
                                        )}
                                    </Field>
                                </div>
                                {/* <div className={styles.btnContainer}> */}
                                <MeritoButton type='secondary-2' onClick={() => {
                                    console.log('applyTo all');
                                    if (formValues?.applyToAll) {
                                        const updatedMonths = formValues?.months.map((month) => {
                                            return {
                                                ...month,
                                                installmentAmount: formValues?.applyToAll
                                            }
                                        })
                                        // console.log('updatedMonths', updatedMonths)
                                        change('months', updatedMonths)

                                    }
                                }} btnText="Apply To All" />
                                {/* </div> */}
                            </div>
                            <div className={styles.monthsRootContainer}>

                                {formValues['months'] && formValues['months'].length ? (
                                    <>
                                        {isFieldArrayTouchedOrVisited.isTouched && monthsMeta.error && monthsMeta.error.length > 0 && <div className={styles.errorMessage}>{monthsMeta.error[0]['installmentAmount']}</div>}
                                        <div className={styles.installmentHeading}>
                                            Instalment Amount Paid in
                                        </div>
                                        <FieldArray name='months'>
                                            {({ fields }) => {
                                                return (
                                                    <>
                                                        {fields.map((name, index) => {
                                                            const currentMonthValue = formValues.months[index];
                                                            return (
                                                                <>
                                                                    {formValues.months[index].isSeparator ? <div className={styles.separator}></div> : null}
                                                                    <div className={styles.monthsContainer}>
                                                                        <div className={styles.leftContainer}>
                                                                            <div className={styles.monthLabel}>
                                                                                {`${moment(formValues.months[index].monthYear, "MM-YYYY").format("MMM YYYY")}`}
                                                                            </div>
                                                                        </div>
                                                                        <div className={styles.inputFieldContainer}>
                                                                            <Field
                                                                                name={`${name}.installmentAmount`}

                                                                            // validate={(value) => {
                                                                            //     if (!value) return "Enter at least one month’s value to Add";
                                                                            // }}
                                                                            >
                                                                                {(props) => (

                                                                                    <OutlinedFormInput
                                                                                        {...props.input}
                                                                                        showError={false}
                                                                                        inpuType="number"
                                                                                        disabled={isInstallmentSectionDisabled}
                                                                                        // containerStyles={{ borderTopRightRadius: '0', borderBottomRightRadius: '0', borderRight: "none", padding: "0.52rem 0.75rem" }}
                                                                                        name={props.input.name}
                                                                                        // value={values?.months[index].isPercentage ? props.input.value : formatNumberWithComma(props.input.value)}
                                                                                        value={props.input.value}


                                                                                        onChange={(e) => {
                                                                                            // console.log('value', e.target.value)
                                                                                            const numericValue = parseNumberForDB(e.target.value, false);
                                                                                            console.log('numeric value', numericValue)
                                                                                            props.input.onChange(numericValue);
                                                                                        }}
                                                                                        error={props.meta.error}
                                                                                        touched={props.meta.touched}
                                                                                        onBlur={(e) => {

                                                                                            // console.log('onBlur triggering')
                                                                                            // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                                                                                            const value = props.input.value;
                                                                                            console.log('value', value);
                                                                                            // console.log('value', value);
                                                                                            const formattedValue = onBlurFormatNumber(value, 0);
                                                                                            // console.log('formattedValue', formattedValue);
                                                                                            props.input.onChange(formattedValue);
                                                                                            console.log('inputValue', value)
                                                                                            props.input.onBlur(e);
                                                                                        }}
                                                                                        unitPlaceHolder={'₹'}
                                                                                        maxLength={21}
                                                                                        isCurrency={true}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </>
                                                )
                                            }}
                                        </FieldArray>
                                    </>
                                ) : null}
                            </div>
                        </>
                    }
                </div>
            }




        </>
    );
}

export default LoanFormInstallment;